<style lang="scss">
    .cusdetail .ivu-date-picker{
        width: 100%
    }
</style>

<template>
    <div class="cusdetail">
        <div>
            <div v-if="type=='query'">
                <span class="margin-left-20">Issue Id <span class="font-16 font-bold">{{formData.issueId}}</span></span>
                <vTable
                class="margin-left-20 margin-right-20"
				:columns="querycolumns" 
				:data="formList"
				size="small" 
				ref="tablequery"  
				border 
                ></vTable>
            </div>
            <div v-else class="text-center">
                <vForm :label-width="80" inline>
                    <vFormItem label="issue ID" style="width:50%" :rules="required" prop="issueId">
                        <vInput v-model="formData.issueId"  style="width:80%;float:left"></vInput>
                        <vButton theme="primary" @click="addItem">{{$t('erp.product.new_add',{defaultValue:'添加'})}}</vButton>
                    </vFormItem>
                </vForm>
                <vTable
                class="margin-left-20 margin-right-20"
				:columns="columns" 
				:data="formList"
				size="small" 
				ref="tableedit"  
				border 
                ></vTable>
            </div>
        </div>
    </div>
</template>
<script>
import { constants } from 'fs';
export default {
    props:['opDetail','formtype','EnterissueId','querytype'],
    data(){
        return {
            datalist:[],
            formData:{
                issueId:'',
            },
            required: [{
                required: true,
                message: this.$t("global.common.fill_requiredd",{defaultValue:'该信息不能为空,请填写'})
            }],
            type:this.$route.params.type || this.querytype,
            // nowdate:"",
        }
    },
    created(){
        // console.log(this.formtype)
        if(this.formtype=='query'){
            this.type = 'query'
        }
    },
    computed:{
        formList(){
            this.datalist = this.opDetail
            // console.log(this.datalist)
            return this.datalist
        },
        columns() {
            let _this = this
            return [
                {
                    title: this.$t("erp.aftersales.number",{defaultValue:'次数'}),
                    width:100,
                    render(h,{row, index}) {
                        return <div class="text-center">{index+1}</div>
                    }
                },
                {
                    // title: "",
                    key: 'issueDescription',
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14",
                                },
                                style:"margin-right:5px"
                            }),
                            h('strong','Issue Description')
                        ])
                    },
                    render(h, { row,index }) {
                        return h('vInput',{
                            props: {
                                size:'small',
                                value:row.issueDescription
                            },
                            on: {
                                'input':(event) => {
                                    row.issueDescription = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }
                },
                {
                    // title: "",
                    key: 'followUp',
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14"
                                },
                                style:"margin-right:5px"
                            }),
                            h('strong','Follow Up')
                        ])
                    },
                    render(h, { row,index }) {
                        return h('vInput',{
                            props: {
                                size:'small',
                                value:row.followUp
                            },
                            on: {
                                'input':(event) => {
                                    row.followUp = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }
                },
                {
                    key: 'issueAt',
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14"
                                },
                                style:"margin-right:5px"
                            }),
                            h('strong',this.$t("erp.aftersales.cusTime",{defaultValue:'客诉时间'}))
                        ])
                    },
                    render(h, { row,index }) {
                        // if(row.$Edit){
                            return h('vDatepicker',{
                                attrs: {
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    transfer:true,
                                    value:_this.datalist[index].issueAt
                                },
                                on: {
                                    'on-change':function(date){
                                        // console.log(date)
                                        _this.datalist[index].issueAt = date
                                    },
                                },
                            })
                        // }else{
                            // return <div>{row.shipmentDate}</div>
                        // }
                    }
                },
                {
                title: this.$t("global.common.actions",{defaultValue:'操作'}),
                width:120,
                render(h, { row, index }) {
                    return h('div',[
                        h('Button', {
                            props:{
                                type:"error",
                                size:'small'
                            },
                            on: {
                                click: () => {
                                    _this.comremove(index)
                                }
                            }
                        },this.$t("global.common.delete",{defaultValue:'删除'}))
                    ])
                }
            }
            ]
        },
        querycolumns(){
            return [
                {
                    title: this.$t("erp.aftersales.number",{defaultValue:'次数'}),
                    width:100,
                    render(h,{row, index}) {
                        return <div class="text-center">{index+1}</div>
                    }
                },
                {
                    title: "Issue Description",
                    key:'issueDescription',
                },
                {
                    title: "Follow Up",
                    key:'followUp',
                },
                {
                    title: this.$t("global.datepicker.time",{defaultValue:'时间'}),
                    width:200,
                    key:'issueAt',
                },
            ]
        },
    },
    methods:{
        // getNowFormatDate(){
            // let date = new Date();
            // let seperator1 = "-";
            // let seperator2 = ":";
            // let year = date.getFullYear();
            // let month = date.getMonth() + 1;
            // let strDate = date.getDate();
            // let hours = date.getHours();
            // let minutes = date.getMinutes();
            // let seconds = date.getSeconds();
            // if (month >= 1 && month <= 9) {
            //     month = "0" + month;
            // }
            // if (strDate >= 0 && strDate <= 9) {
            //     strDate = "0" + strDate;
            // }
            // let currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + hours + seperator2 + minutes + seperator2 + seconds;
        // },
        addItem(){  
            // 转换成GMT系统时间
            let gmttome = this.$moment().tz("GMT").format('YYYY-MM-DD HH:mm:ss');
            // this.nowdate =  gmttome;
            let _this = this
            let data = {
                issueDesc:'',
                follow:'',
                issueAt:gmttome,
            }
            this.datalist.push(data)
        },    
        comremove(index){
            this.datalist.splice(index, 1);
        }
    },
    watch:{
        'EnterissueId':function(val){
            this.formData.issueId = val
        }
    }
}
</script>

